import { useForm } from "@mittwald/flow-components/dist/components/Form";
import { WizardStep } from "@mittwald/flow-components/dist/components/Wizard/components/WizardStep";
import type { WizardState } from "@mittwald/flow-components/dist/components/Wizard/state/model";
import type { AnimationController } from "@mittwald/flow-components/dist/hooks/useAnimationController";
import React from "react";
import { useCodeInputAutoSubmit } from "../../../../../../hooks/useCodeInputAutoSubmit";
import { relocationWidgetStore } from "../../../store/RelocationWidgetStore";
import { LegacySystemAPI } from "../../../utils/LegacySystemAPI";
import { DeviceCookieStepContent } from "./DeviceCookieStepContent";

export interface DeviceCookieStepProps {
  isNewSystem: boolean;
  rejectionAnimation: AnimationController;
  email: string;
  password: string;
  wizardState: WizardState;
}

export const DeviceCookieStep: React.FC<DeviceCookieStepProps> = (props) => {
  const { isNewSystem, rejectionAnimation, email, password, wizardState } =
    props;

  const deviceCookieForm = useForm<{
    deviceCookie: string;
  }>({
    defaultValues: {
      deviceCookie: "",
    },
    onSubmit: async (values) => {
      if (!isNewSystem) {
        const result = await LegacySystemAPI.login(
          email,
          password,
          values.deviceCookie,
        );

        if (result.token) {
          relocationWidgetStore.updateAccessToken(result.token);
          wizardState.gotoStep("target");
        }
      }
    },
  });

  useCodeInputAutoSubmit(deviceCookieForm);

  return (
    <WizardStep
      form={deviceCookieForm}
      id="deviceCookie"
      indicatorText="deviceCookie"
      noReturn
    >
      <DeviceCookieStepContent rejectionAnimation={rejectionAnimation} />
    </WizardStep>
  );
};
